import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { HitStatusBulkStore } from './hit-status-bulk-store.interface';
import { hitStatusBulkStoreService } from './hit-status-bulk-store.service';
const service = new hitStatusBulkStoreService();

export interface hitStatusBulkStoreState {}

const hitStatusBulkStoreStore: Module<hitStatusBulkStoreState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async hitStatusBulkStore(context, hitStatusBulkStore: HitStatusBulkStore) {
         const response = await service.bulkUpdateStatuses(hitStatusBulkStore);
         return response;
      },
   },
};

export default hitStatusBulkStoreStore;
